import React from 'react';
import AccountSetupFlow from '../components/account-setup/AccountSetupFlow';

const AccountSetupPage = () => {
  return <AccountSetupFlow />;
};

export default AccountSetupPage; 